import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import {
  getTree,
  getFile,
  refreshTree,
  // selectMultipleFiles,
  resetPayload,
  ERROR_FILE,
  BULK_REVIEW_ADD_FILE_COUNT
} from "store/actions/fileAction";
import { SpinnerRainbow } from "components/Spinner";
import Notification from "components/Notification";
import ChildNodes from "./ChildNodes";
import Search from "./Search";
import Translate from "helpers/Translate";

// Styles
import "./style.css";

function TreeView() {
  const dispatch = useDispatch();
  // const multipleSelectedFiles = useSelector(
  //   state => state.file.multipleSelectedFiles
  // );
  const isLoadingTree = useSelector(state => state.file.isLoadingTree);
  const doRefresh = useSelector(state => state.file.doRefresh);
  const treePaths = useSelector(state => state.file.getTreeNodes);
  const bulkReviewFilesCount = useSelector(
    state => state.file.getBulkReviewFilesCount
  );
  const fileStatus = useSelector(state => state.file.getActiveTab);
  const selectedClient = useSelector(state => state.client.selectedClient);
  const selectedSubordinate = useSelector(state => state.file.getSubordinate);

  // Load tree
  useEffect(() => {
    if (selectedClient && fileStatus && selectedSubordinate) {
      dispatch(
        getTree({
          client: selectedClient,
          fileStatus,
          subordinateId: selectedSubordinate?.id || ""
        })
      );
    }
  }, [selectedClient, fileStatus, selectedSubordinate, dispatch]);

  // Force-Refresh tree
  useEffect(() => {
    if (doRefresh && selectedClient && fileStatus && selectedSubordinate) {
      dispatch(
        getTree({
          client: selectedClient,
          fileStatus,
          subordinateId: selectedSubordinate?.id || ""
        })
      );
      dispatch(refreshTree(false));
    }
  }, [doRefresh, selectedClient, fileStatus, selectedSubordinate, dispatch]);

  // Get the file count after adding to bulk review
  useEffect(() => {
    if (bulkReviewFilesCount) {
      Notification.success(
        Translate({
          id: "file_were_added_to_bulk_review_list",
          values: [bulkReviewFilesCount]
        })
      );
      dispatch(resetPayload(BULK_REVIEW_ADD_FILE_COUNT));
    }
  }, [bulkReviewFilesCount, dispatch]);

  function handleOnItemSelected(selectedItem) {
    if (selectedItem.isDirectory === true) return;
    dispatch(getFile(selectedItem.id));
    dispatch(resetPayload(ERROR_FILE));
  }

  // async function handleBulkSend(fileDocs = []) {
  //   if (!Array.isArray(fileDocs) || !fileDocs.length) {
  //     return Notification.error(
  //       Translate({ id: "no_items_to_add_to_bulk_review" })
  //     );
  //   }

  //   dispatch(
  //     saveBulkReview({
  //       fileDocs,
  //       isDirectory: true,
  //       flushOld: false
  //     })
  //   );
  //   if (!fileDocs.length)
  //     return Notification.warning(
  //       Translate({ id: "no_files_were_added_to_bulk_review_list" })
  //     );
  // }

  // function handleOnCheckboxSelect(e, item) {
  //   const isChecked = e.target.checked;
  //   let allFiles = multipleSelectedFiles ? [...multipleSelectedFiles] : [];
  //   if (isChecked) {
  //     // If checkbox is checked, add item to array
  //     allFiles.push(item);
  //   } else {
  //     // If checkbox is unchecked, remove item from array
  //     allFiles = allFiles.filter(i => i.id !== item.id);
  //   }
  //   dispatch(selectMultipleFiles(allFiles));
  // }

  return (
    <>
      {/* Search Bar */}
      <Search />
      <div className="container">
        {/* Loader */}
        <div className="">
          {isLoadingTree && <SpinnerRainbow width={100} />}

          {/* No Results */}
          {!isLoadingTree && isEmpty(treePaths) ? (
            <div className="item center mt-20">
              {Translate({ id: "no_documents_found" })}{" "}
            </div>
          ) : null}

          {/* File Tree */}
          {!isLoadingTree &&
            !isEmpty(treePaths) &&
            treePaths.map(item => (
              <ChildNodes
                key={item.id}
                item={item}
                // selectedFile={selectedFile}
                fileStatus={fileStatus}
                selectedClient={selectedClient}
                handleOnItemSelected={handleOnItemSelected}
                // handleOnCheckboxSelect={handleOnCheckboxSelect}
                // handleBulkSend={handleBulkSend}
              />
            ))}
          <div className="mb-30">&nbsp;</div>
        </div>
      </div>
    </>
  );
}

export default TreeView;
